import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

import { FileTransfer } from '../../models/file-transfer.model';

@Component({
  selector: 'app-upload-file',
  templateUrl: './upload-file.component.html',
  styleUrls: ['./upload-file.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class UploadFileComponent {

  @Input() accept: string;
  @Output() uploadFile: EventEmitter<FileTransfer> = new EventEmitter();
  @Output() reset: EventEmitter<void> = new EventEmitter();

  file: File = null;

  constructor() { }

  get size(): string {
    return (this.file.size / Math.pow(1024, 2)).toFixed(5);
  }

  get filename(): string {
    return this.file.name;
  }

  changeFile(): void {
    this.file = null;
    this.reset.emit();
  }

  onFileDrop(files: FileList): void {
    this.handleFile(files.item(0));
  }

  onFileUpload(event: Event): void {
    const element = event.target as HTMLInputElement;
    if (element.files) {
      this.handleFile(element.files.item(0));
    }
  }

  private handleFile(file: File): void {
    let reader: FileReader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      this.file = file;
      this.uploadFile.emit({
        original: file,
        dataURL: reader.result as string
      });
    };
  }

}
